/**
 * <p>****************************************************************************</p >
 * <p><b>Copyright  2013-2019/7/20 soho team All Rights Reserved<b></p >
 * <ul style="margin:15px;">
 * <li>Description : </li>
 * <li>Version     : 1.0</li>
 * <li>Creation    : 2019/7/20</li>
 * <li>@author     : 唐胜</li>
 * </ul>
 * <p>****************************************************************************</p >
 */
import request from '../kernel/request'

export default {
    chat: {
        list(params) {
            return request.get('user/chat/record', params)
        },
        save(data) {
            return request.post(`user/chat/record`, data)
        },
        update(data) {
            return request.put(`user/chat/record`, data)
        },
        delete(id) {
            return request.delete('user/chat/record/' + id)
        },
        load(id) {
            return request.get('user/chat/record/' + id)
        }
    },
    answer: {
        list(params) {
            return request.get('user/answer', params)
        },
        save(data) {
            return request.post(`user/answer`, data)
        },
        update(data) {
            return request.put(`user/answer`, data)
        },
        delete(id) {
            return request.delete('user/answer/' + id)
        },
        load(id) {
            return request.get('user/answer/' + id)
        },
        uploadUrl: `${request.baseURL}/upload`
    },
    question: {
        list(params) {
            return request.get('user/question', params)
        },
        save(data) {
            return request.post(`user/question`, data)
        },
        update(data) {
            return request.put(`user/question`, data)
        },
        delete(id) {
            return request.delete('user/question/' + id)
        },
        load(id) {
            return request.get('user/question/' + id)
        }
    }

}